<!-- Historique des dépôts Projet -->
<fuse-card class="w-4/5 mx-auto mt-8 flex flex-col p-8 md:p-12">

    <h2 class="text-xl font-bold text-gray-800 mb-6 flex items-center gap-2">
        <mat-icon class="text-primary" [svgIcon]="'heroicons_outline:clock'"></mat-icon>
        Historique des dépôts
    </h2>

    <div class="mb-2">
        <span class="text-sm font-semibold text-gray-500 uppercase tracking-wide">Projet</span>
    </div>

    <div class="flex flex-col gap-4">
        <div *ngFor="let project of paginatedGroups"
            class="bg-gray-50 border border-gray-200 rounded-2xl p-6 shadow-sm">

            <div class="flex items-center justify-between mb-4">
                <div class="flex items-center gap-3">
                    <a (click)="goToProject(project, $event)"
                        class="font-bold text-lg hover:underline cursor-pointer flex items-center gap-2 text-accent">
                        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:folder'"></mat-icon>
                        {{ project.projectReference }}
                    </a>
                    <!-- Nom du partenaire uniquement si aucun partner sélectionné -->
                    <span *ngIf="showPartnerName && project.partnerName"
                        class="text-sm text-gray-500 font-medium border-l border-gray-300 pl-3">
                        {{ project.partnerName }}
                    </span>
                </div>
                <span class="text-sm text-gray-400 italic">
                    {{ (project.createdOnUtc + 'Z') | date:'d MMM yyyy, HH:mm:ss' : '' : 'fr' }}
                </span>
            </div>


            <!-- Fichiers -->
            <div class="flex flex-wrap gap-3" *ngIf="project.files?.length > 0">
                <div *ngFor="let file of project.files"
                    class="flex items-center gap-2 bg-white border border-gray-200 rounded-lg px-3 py-2 shadow-sm hover:shadow-md transition">
                    <mat-icon class="icon-size-4 text-gray-500" [svgIcon]="'heroicons_outline:paper-clip'"></mat-icon>
                    <span class="text-sm text-gray-700">{{ file.name }}</span>
                    <button (click)="clickDownloadFile(file)" title="Télécharger"
                        class="ml-1 hover:text-primary transition">
                        <mat-icon class="icon-size-4 text-primary"
                            [svgIcon]="'heroicons_outline:document-download'"></mat-icon>
                    </button>
                </div>
            </div>

            <div *ngIf="!project.files?.length" class="text-sm text-gray-400 italic">
                Aucun fichier joint
            </div>
        </div>
    </div>

    <!-- Empty state -->
    <div *ngIf="!projectGroups?.length" class="flex flex-col items-center justify-center py-12 text-gray-400">
        <mat-icon class="icon-size-12 mb-3" [svgIcon]="'heroicons_outline:inbox'"></mat-icon>
        <span class="text-sm">Aucun dépôt pour le moment</span>
    </div>

    <!-- Pagination -->
    <div class="flex justify-center items-center mt-8 space-x-6" *ngIf="totalPages > 1">
        <button mat-stroked-button color="accent" (click)="previousPage()" [disabled]="currentPage === 0">
            Précédent
        </button>
        <span class="text-sm text-gray-600">Page <b>{{ currentPage + 1 }}</b> sur <b>{{ totalPages }}</b></span>
        <button mat-stroked-button color="accent" (click)="nextPage()" [disabled]="currentPage + 1 >= totalPages">
            Suivant
        </button>
    </div>
</fuse-card>